<router-outlet></router-outlet>

<p-toast position="top-right"></p-toast>

<!-- confirm dialog for global actions -->
<p-confirmDialog #cd [baseZIndex]="9000" [dismissableMask]="true" key="global"
	[closable]="true" defaultFocus='accept' header="Confirmation required" class="custom-confirm-dialog">
	<ng-template pTemplate="header">
		<i class="p-dialog-titlebar p-dialog-titlebar-icon" class="mdi mdi-alert" style="color: coral;"></i>
		<h5>{{ cd.header }}</h5>
		<button pRipple type="button" class="p-link" (click)="cd.reject()"
			(keydown.enter)="cd.reject()" i18n-title title="Close">
			<i class="mdi mdi-close"></i>
		</button>
	</ng-template>
	<ng-template pTemplate="footer" style="text-align: center;">
		<button pButton type="button" icon="pi pi-check" i18n-label label="Yes" (click)="cd.accept()"
			style="margin: 0 auto; display: block;"></button>
	</ng-template>
</p-confirmDialog>

<!-- confirm dialog for general actions -->
<p-confirmDialog #generalCd [baseZIndex]="9000" [dismissableMask]="true" key="general"
	[closable]="true" defaultFocus='accept' header="Confirmation required" i18n-header class="custom-confirm-dialog">
	<ng-template pTemplate="header">
		<i class="mdi mdi-alert" style="color: coral;"></i>
		<h5>{{ generalCd.header }}</h5>
		<button pRipple type="button" class="p-link" (click)="generalCd.close($event)" i18n-title title="Close">
			<i class="mdi mdi-close"></i>
		</button>
	</ng-template>
	<ng-template pTemplate="footer">
		@if (generalCd?.confirmation?.acceptLabel) {
			<button pButton type="button"
				[label]="generalCd?.confirmation?.acceptLabel || 'Yes'"
				[icon]="generalCd?.confirmation?.acceptIcon || 'pi pi-check'"
				(click)="generalCd.accept()">
			</button>
		}
		@if (generalCd?.confirmation?.rejectLabel) {
			<button pButton type="button"
				[label]="generalCd?.confirmation?.rejectLabel || 'No'"
				[icon]="generalCd?.confirmation?.rejectIcon || 'pi pi-times'"
				(click)="generalCd.reject()">
			</button>
		}
	</ng-template>
</p-confirmDialog>
